'use strict';exports.__esModule = true;var _constants = require('../constants');

var getManagePropertiesRowsPerPage = function getManagePropertiesRowsPerPage() {var
  firstOption = _constants.MANAGE_PROPERTIES_ROWS_PER_PAGE_OPTIONS[0];

  if (typeof localStorage === 'undefined') {
    return firstOption.value;
  }

  try {
    var valueInStorage = localStorage.getItem('rows-on-page');

    if (!valueInStorage) return firstOption.value;

    var parsedValue = JSON.parse(valueInStorage);

    if (parsedValue && parsedValue.value) {
      if (
      _constants.MANAGE_PROPERTIES_ROWS_PER_PAGE_OPTIONS.some(
      function (option) {return option.value === parsedValue.value;}))

      {
        return parsedValue.value;
      }
      localStorage.setItem('rows-on-page', JSON.stringify(firstOption));
    }

    return firstOption.value;
  } catch (e) {
    console.error('Failed to read "rows-on-page" from localStorage', e);
    return firstOption.value;
  }
};exports.default =


getManagePropertiesRowsPerPage;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/getManagePropertiesRowsPerPage.js
// module id = 295
// module chunks = 0